import axios from 'axios';
import Router from 'vue-router';
import store from '../store';
import router from './router';
import config from '../../static/config.json';

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // const token = store.getters.getToken; 
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);



// http response 拦截器
axios.interceptors.response.use(
  res => {
    return res;
  }, err => {
    if (err.response) {
      switch (err.response.status) {
        case 401: 
          // sessionStorage.setItem("login", "false"); // 清除登录状态
          // router.push({
          //   path: '/auth'
          // });
          break;
        case 404:
          router.replace({
            path: '/404'
          });
          break;
        case 500:
          router.replace({
            path: '/500'
          });
          break;
      }
    }
    return Promise.reject(err);
  }
);

export default axios;
